import { render, staticRenderFns } from "./InscrevaSe.vue?vue&type=template&id=5239fd13&"
import script from "./InscrevaSe.vue?vue&type=script&lang=js&"
export * from "./InscrevaSe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports